import { render, staticRenderFns } from "./AdminUsersPage.vue?vue&type=template&id=7b8e65b6&scoped=true"
import script from "./AdminUsersPage.vue?vue&type=script&lang=js"
export * from "./AdminUsersPage.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersPage.vue?vue&type=style&index=0&id=7b8e65b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e65b6",
  null
  
)

export default component.exports